export enum MonthsCheckboxesSize {
    big = 'big',
    small = 'small',
}
